/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * ZH SP resource file
 */
export const labels = {
	title: 'EY Canvas Economics',
	status: '状态',
	header: '标题',
	canvas: 'Canvas',
	canvasEconomics: 'Canvas 经济',
	badRequest: '无效请求',
	errorBanner: '{0}错误',
	userProfileDropdown: {
		myProfile: '我的配置文档',
		signOut: '注销'
	},
	clientCode: '客户编码',
	hours: '小时',
	local: '本地',
	currency: '货币',
	rate: '费率',
	forecast: '预测',
	variance: '偏差',
	edit: '编辑',
	arrowUp: '向上箭头',
	budget: '预算',
	priorBudget: '前期预算',
	currentBudget: '当期预算',
	summary: '汇总',
	actual: '实际',
	priorActual: '前期实际支出',
	currentActual: '当期实际支出',
	remaining: '剩余',
	adjustment: '调整',
	estimate: '估计',
	isRequired: '{0}为必填',
	isPositiveInteger: '{0}为必填，并且必须是非负整数。',
	isPositiveDecimal: '{0}为必填，并且必须是正数，保留两位小数。',
	in: '在',
	id: 'ID',
	currentYear: '本年度',
	priorYear: '上年度',
	budgetHierarchy: '预算级次',
	executionBudgetHierarchy: '执行预算级次',
	noContentAvailable: '无可用内容',
	viewMore: '查看更多',
	budgetExecutionPhase: '对{0}内所有对象的预算',
	details: '详细',
	unallocated: '未分配',
	none: '无',
	thousands: '千',
	millions: '百万',
	lakhs: '十万',
	crores: '千万',
	budgetObjectName: '预算对象名称',
	editActivityCodes: '编辑活动编码',
	save: '保存',
	send: 'Send',
	cancel: '取消',
	searchActivityCodes: '搜索活动编码',
	noActivityCodesAvailable: '没有可用的活动编码',
	select: '选择',
	engagementCode: '项目代码',
	engagementCodeName: 'Engagement code name',
	activityCode: '活动编码',
	activityCodeDescription: '活动编码描述',
	searchActivityCodesPlaceholderText: '搜索活动编码',
	addMember: '添加成员',
	closeLabel: '关闭',
	cancelLabel: '取消',
	seachInputRequired: '搜索输入为必填',
	nameOrEmail: '姓名或邮箱',
	emailForExternal: '邮箱',
	noRecord: '未找到结果',
	userSearchPlaceholder: '输入姓名或邮箱，然后按回车键查看结果。',
	userSearchPlaceholderForExternal: '输入邮箱，然后按回车键查看结果。',
	clearAllValues: '清除所有值',
	clear: '清空',
	inValidEmail: '请输入有效的邮箱',
	invalidClientCode: '无效客户编码',
	railSearchText: '搜索',
	open: '打开',
	remove: '删除',
	leave: '离开',
	delete: '删除',
	markAsCompleted: '标记为已完成',
	budgetedHours: '预算的工时',
	forecastedHours: '预测工时',
	actualHours: '实际工时',
	ftaVariance: 'FTA差异',
	ftaVarianceTooltip: '预测值与实际值偏差',
	usedHours: '使用的工时数',
	etcHours: '预计完成时间小时数',
	createProjectCard: '创建项目',
	plusClients: '+{0}客户',
	plusCodes: '+{0}客户编码',
	clientNames: '客户名称：',
	clientName: '客户名称：',
	clientNameLabel: 'Client name',
	clientCodes: '客户编码：',
	clientCodeCard: '客户编码：',
	financialAnalysis: "财务分析",
	billingExpenses: '账单和费用',
	independence: "独立性 ",
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel: 'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	notApplicable: 'Not applicable',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients: 'No associated client',
	noCanvasEngagementsIdentified: 'No EY Canvas engagements identified',
	placeholderForSearch: 'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: '按xxx显示数据',
	financialDetails: '财务细节',
	actualHoursToDate: '迄今实际工时',
	byWeekEndingDate: '每周结束日期',
	ClickAndDrag: '点击和拖放图中某个区域以放大查看',
	etc: '估计的完成时长',
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: '任务和里程碑',
	milestonesOverdue: '逾期里程碑',
	milestoneOverdue: '逾期里程碑',
	inProgress: '进行中',
	inReview: '复核中',
	Complete: '完成',
	assignments: '工作分配',
	assignment: '工作分配',
	assignmentsOverdue: '已逾期的任务',
	assignmentOverdue: '逾期的工作分配',
	overdue: '逾期',
	requestOverdue: '逾期请求',
	requestsOverdue: '逾期请求',
	total: '合计',
	complete: '完成',
	closed: '已关闭',
	Unassigned: '未分配',
	unassigned: '未分配',
	sent: '已发送',
	totalTask: '总任务',
	collaboration: '协作',
	received: '已接收',
	accepted: '已接受',
	outstanding: '未完成',
	unsentDrafts: '未发送的草稿',
	draft: '草稿',
	drafts: '草稿',
	returned: 'returned',
	draftRequests: '请求草稿',
	percent: '百分比',
	preparer: '编制人',
	reviewer: '复核人',
	NoDataForSelectedOptions: 'No information available for the selected options.',
	NoAssignmentDataForSelectedOptions: 'Engagement is not using the Assignment feature',
	NoCollabDataForSelectedOptions: '项目没有使用协作功能',
	tasks: '任务',
	totalTasks: '总任务',
	requests: '请求',
	requestSent: '已发送请求',
	requestsSent: '已发送请求',
	expandDetails: '展开详细信息',
	onlyProjectAdministratorsCanEdit: '仅项目管理员可以编辑',
	onlyProjectAdministratorsCanDelete: '仅项目管理员可以删除项目',
	userOptions: '用户选项',
	userOptionsDropdown: {
		userSettings: '用户设置',
		delegateAccess: '管理受托人',
		privacyNotice: 'Privacy notice',
		signOut: '注销'
	},
	delegateToInstruction: '将访问权限委托给同事，以便其代你验证项目代码。委托人将能够验证你有权访问的所有项目代码。',
	delegateFromInstruction: '以下用户已委托其验证项目代码的权限。',
	delegateAccess: '管理受托人',
	addDelegates: '添加受托人',
	addAnother: '添加新的受托人',
	hideMyDelegate: '隐藏经我授权的受托人',
	showMyDelegate: '显示经我授权的受托人',
	duplicateUser: '该受托人已被添加',
	informationRequired: '该信息为必填',
	delegateTo: '受托人',
	delegateFrom: '委托人',
	noDelegatesAdded: '未添加受托人',
	noDelegationReceived: '未收到委托。',
	removeDelegateMessgae: '请确定是否删除该受托人？删除后，该受托人将不可再代你验证财务项目代码。',
	removeDelegateTitle: '删除受托人',
	delegate: '受托人',
	saveAndClose: '保存并关闭',
	resetZoom: 'Reset zoom',
	exportData: 'Export data',
	rankCode: 'Rank code',
	userGui: 'User GUI',
	email: 'Email',
	globalAnsr: 'Global ANSR',
	globalCost: 'Global cost',
	globalMargin: 'Global margin',
	localAnsr: 'Local ANSR',
	localCost: 'Local cost',
	localMargin: 'Local margin',
	weekEnding: 'Week ending',
	welcomeToEconomics: 'Welcome to the EY Canvas Economics ',
	adminPortal: 'administrative portal',
	home: 'Home',
	enterFirstNameText: 'Enter first name, last name or email address of user and press enter to search',
	addBtn: '添加',
	cancelBtn: 'Cancel',
	close: '关闭',
	selectRole: 'Role',
	upsText: 'Ups!',
	sufficientRightsToAccess: 'You do not have sufficient rights to access this page',
	detailedInformation: 'Detailed information may vary from summary data presented due to timing differences of when data is made available.',
	noResultFound: 'No results match the search criteria',
	loading: 'Loading...',
	search: '搜索',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',

	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: '展开',
	collapse: 'Collapse',
	bulkSendIndependenceLabel: 'Bulk send independence confirmation',
	independenceStatusInviteUserLabel: 'Add internal team member as Independence only',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
	clickToInviteUser: 'to send independence confirmation',
	click: 'Click',
	invitePending: 'Invite pending',
	engagementRolePlaceholder: 'Engagement role',
	engagementRoleRequiredErrorMessage: 'Please select the engagement role for the selected team member',
	engagementInvitationSuccessToastMessage: 'You have successfully sent the independence confirmation(s).',
	engagementInvitationFailureToastMessage: 'Failed to send the independence confirmation(s), Please retry. If issue persists, reach out to the Help desk.',
	independenceInviteConfirmationMessage: 'Independence confirmation has been sent. Response is pending.',
	engagementRoleRequiredOverAllErrorMessage: 'An engagement role has not been selected for one or more users. Select the engagement role from the drop down to proceed with sending the Independence confirmation.',
	administrativeContractor: 'Administrative contractor',
	notAvailable: 'Not Available',
	allocation: 'Allocation',
};

export const errors = {
	default: '发生错误。请联系帮助台。',
	102: '无效项目。',
	106: 'RBAC授权被拒绝。',

	1001: '未找到用户。',
	1002: '用户获取全部指令失败。',
	1003: '用户GUI不能为空。',
	1004: '请求不得为空。',
	1005: "无法创建用户，存在和该用户有相同GUI的用户。",
	1006: '找到多个有相同GUI的用户。',
	1007: '该用户不是活跃用户。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1008: '选择的数字格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1009: '选择的取整格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1010: '选择的货币格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1011: '选择的日期格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1012: '选择的语言无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1013: '名字过短或过长。请重试。',
	1014: '姓氏过短或过长。请重试。',
	1015: '选择的负数格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。',
	1016: "用户不存在，无法更新。",
	1017: '获得用户首选项时发生错误。API指令失败。',
	1018: '在创建用户时发生了错误。API指令失败。',
	1019: '更新用户首选项时发生错误。API指令失败。',
	1020: '用户不是活跃用户。刷新页面，然后重试。如果仍有错误，请联系帮助台。',
	1021: '所选主题值无效。刷新页面，然后重试。如果仍有错误，请联系帮助台。',
	1022: '所选货币值无效。刷新页面，然后重试。如果仍有错误，请联系帮助台。',
	1023: '用户无权从项目中删除已请求的项目组成员。',
	1024: '在创建委托用户时发生了错误。API指令失败。',
	1025: '委托用户列表不能为空。',
	1026: '用户名太长或太短。',
	1027: '用户GUI无效。',
	1028: '用户邮件地址太长或太短。',
	1029: '用户ID不能为空。',
	1030: '用户名不能为空。',
	1031: '用户邮件地址不能为空。',
	1032: '用户不在被授予删除访问权限的委托人之列。',
	1033: '用户不在授予删除访问权限的授予委托人之列。',
	1034: '用户已在委托人之列。',
	1035: '用户ID长度不符合规则。请重新输入正确的用户ID。',
	1036: '登录的用户不在列表中。请稍后重试。',
	1040: 'You do not have administrator rights. Please contact the help desk.',

	7001: '项目元数据指令失败。',
	7006: 'EY Canvas目前无法访问。刷新页面，然后重试。如果问题仍然存在，请联系帮助台。',

	8003: '从CDS API获得项目详细信息时出错。',
	8006: 'EY Canvas目前无法访问。刷新页面，然后重试。如果问题仍然存在，请联系帮助台。',
	8004: '未找到项目代码。如果是Mercury代码，请确保其中包括项目类型。  请重试，如果问题仍然存在，请联系帮助台。',
	8007: 'Error while getting Engagement Details from CDS API.',
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: '请求不能为空',
	9002: '项目客户代码信息栏不能为空',
	9003: '项目名称信息栏不能为空。',
	9004: '百分比信息栏不能为空。',
	9005: '费率信息栏不能为空。',
	9006: '预算没有关联任何选定的项目。',
	9007: '项目唯一识别符不能为空。',
	9008: '项目客户名称不能为空。',
	9009: '项目描述不能为空。',
	9010: '项目客户唯一识别符不能为空。',
	9011: '关联的项目系统不能为空。',
	9012: '关联项目唯一识别符不能为空。',
	9013: '关联项目名称不能为空。',
	9014: '关联项目客户唯一识别符不能为空。',
	9015: '关联项目客户名称不能为空。',
	9016: '添加的关联项目不能为空。',
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: 'One or more Related engagement Codes are invalid.',
	9019: "项目百分比应大于零。",
	9020: "项目百分比不应超过两位小数。",
	9021: "项目费率应大于零。",
	9022: '项目ID无效。',
	9023: 'Get call for financial analysis failed.',
	9024: '未找到项目详细信息',
	9025: '获得标题指令失败。',
	9026: 'No results match the search criteria.',
	9027: '无效汇总类型。',
	9028: '当前用户没有项目访问权限。',
	9029: '未找到项目收费账单的详细信息。',
	9030: "Project Financial Filters not found.",
	9031: "A user's name is either too long or too short.",
	9032: "A user's GUI is invalid.",
	9033: "A user's email address is either too long or too short.",
	9034: 'At least one team member should have project administrator role.',
	9035: '你是该项目的最后一位活跃项目管理员用户。删除该项目，将其从你的登陆页中移除。如无法删除，请联系帮助台。',
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: 'Please remove some team members because the quantity exceeds the {0}.',
	9038: 'Please remove some Engagement codes because the quantity exceeds the {0}.',
	9039: '项目用户数量必须大于零。',
	9040: 'Unvalidated Financial Codes must not be null or empty strings, and their length cannot surpass 50 characters.',
	9041: '项目ID不能为空。',
	9042: '无法完成删除操作。请重试，如果仍有错误，请联系帮助台。',
	9043: '当前用户没有编辑项目所需的权限。',
	9044: 'Project Financial Details call failed.',
	9045: 'Project status is not valid.',
	9046: 'Project user status is not valid.',
	9047: 'Invalid project user role.',
	9048: 'Project name should be within 500 characters.',
	9049: 'Project user first name cannot be empty.',
	9050: 'Project user last name cannot be empty.',
	9051: 'Project user GUI cannot be empty.',
	9052: 'Project user email cannot be empty.',
	9053: 'Project user admin flag cannot be empty.',
	9054: 'Priviledged account cannot be added as project user.',
	9055: 'Project Expense Filters not found.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Financial codes is invalid.',
	9063: 'Independence complete has invalid rationale value.',
	9064: 'Independence complete type has invalid value.',
	9065: 'Project Expense Filters not found.',
	9066: 'Number of engagement ids linked to the project is greater than the maximum allowed number.',
	9067: 'Invalid patch operation.',
	9068: 'Some user already updated the status, refresh the page to view the latest status.',
	9069: 'Independence patch API failed.',
	9070: 'Duplicate financial codes associated to canvas engagement.',
	9071: 'Only single financial codes associated to canvas engagement can be marked as primary code.',
	9072: 'Primary financial codes associated to canvas engagements is invalid.',
	9073: 'Duplicate unvalidated financial codes.',
	9074: 'Duplicate users.',
	9075: 'A user Email is invalid.',
	9076: 'Engagement user creater request body cannot be empty.',
	9077: 'Engagement user create request has duplicate users.',
	9078: 'Engagement user role is invalid.',
	9079: 'Invalid canvas engagement.',
	9080: 'Engagement not mapped to project.',
	9081: 'Engagement user creation request failed.',
	9082: 'Session has been timed out due to inactivity. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Admin error codes*/
	14001: 'User not found',
	14002: 'Admin User call failed',
	14003: 'Admin user found is InActive',
	14004: 'Admin user creation failed',
	14005: 'The first name is either too short or too long. Please try again',
	14006: 'The last name is either too short or too long. Please try again',
	14007: 'Administrator role id is invalid',
	14008: 'The selected user is already an administrator. Please review.',
	14009: 'Admin user search call failed',
	14010: 'User gui cannot be empty',
	14011: 'User gui must be greater than zero',
	14012: 'User id is not valid. Please try again',
	14013: 'Email address is not valid. Please try again',
	14014: 'Logged in user is not same as admin user',
	14015: 'Admin project search call failed',
	14016: 'Admin user already exists but is InActive',
	14017: 'Admin can only be priviledged user account',
	14018: 'Administrator role id cannot be empty.',
	14019: 'Logged in user is not system admin.',
	14020: 'Invaid requestor privileged account.',
	14021: 'Admin can only be priviledged user account.',
	14023: 'Error removing existing admin roles.',
	14024: 'Error adding updated admin roles.',
	14025: 'Admin user id cannot be empty.',

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};
export const roundingOptions = [{
	value: 'none',
	label: '无'
},
{
	value: 'thousands',
	label: '千'
},
{
	value: 'millions',
	label: '百万'
},
{
	value: 'lakhs',
	label: '十万'
},
{
	value: 'crores',
	label: '千万'
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: '英语',
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: '法语',
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: '西班牙语',
	value: 'es'
},
{
	displayLanguageId: 7,
	label: '葡萄牙语',
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: '日语',
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: '中文（简体）',
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: '中文（繁体）',
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: '希伯来语',
	value: 'he'
},
{
	displayLanguageId: 12,
	label: '韩语',
	value: 'ko'
},
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: '数值类型1',
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: '数值类型3',
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: '数值类型7',
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: '数值类型2',
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: '全球',
	label: '全球'
},
{
	value: '本地',
	label: '本地'
}
];

export const themeOptions = {
	light: '浅色',
	dark: '深色'
};

export const currencyOptions = {
	global: '全球',
	local: '本地'
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: '全球'
},
{
	value: 'Local',
	label: '本地'
}
];

export const statusValues = [{
	isActive: true,
	label: 'Active'
},
{
	isActive: false,
	label: 'Inactive'
}
];

export const financialOptions = {
	serviceLine: '业务线',
	subServiceLine: '子业务线',
	teamMember: '项目组成员',
	rank: '职级'
};

export const roles = {
	1: '审计负责合伙人',
	2: '项目合伙人',
	3: '执行总监',
	4: '负责人',
	5: '高级经理',
	6: '经理',
	7: '高级审计员',
	8: '审计员',
	9: '实习生',
	10: '项目质量复核人',
	11: '其他合伙人',
	12: 'GDS——审计员',
	13: '咨询（ITRA、TAS、人力资本或其他）',
	14: '税务',
	15: '管理支持服务',
	16: '总法律顾问',
	17: '审计质量复核人',
	21: '内部审计主管',
	22: '内部审计职员',
	23: '监管者',
	24: '其他（如，尽职调查复核）',
	25: '事务所',
	26: '地区',
	27: '行业',
	28: '国际',
	29: '全球',
	30: 'GDS-高级审计员',
	31: 'GDS-经理'
};

export const serviceLines = [{
	value: 0,
	label: '所有业务线'
},
{
	value: 1,
	label: '咨询'
},
{
	value: 2,
	label: '审计'
},
{
	value: 3,
	label: '法务'
},
{
	value: 4,
	label: '交易咨询服务'
},
{
	value: 5,
	label: '税务'
},
{
	value: 6,
	label: '其他'
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: 'Not available'
},
{
	code: null,
	label: 'Allocation'
},
{
	code: 'ASU',
	label: '审计'
},
{
	code: 'TAS',
	label: 'Strategy and Transactions'
},
{
	code: 'TAX',
	label: '税务'
},
{
	code: 'ADV',
	label: 'Consulting'
},
];

export const userRanks = [{
	id: '11',
	name: '合伙人'
},
{
	id: '12',
	name: '合伙人'
},
{
	id: '13',
	name: '执行总监'
},
{
	id: '21',
	name: '高级经理'
},
{
	id: '32',
	name: '经理'
},
{
	id: '36',
	name: '税务经理'
},
{
	id: '4',
	name: '外派员工'
},
{
	id: '41',
	name: '高级审计员/高级咨询员3级'
},
{
	id: '42',
	name: '高级审计员/高级咨询员'
},
{
	id: '43',
	name: '审计员/咨询员2级'
},
{
	id: '44',
	name: '审计员/咨询员'
},
{
	id: '45',
	name: '高级审计员/高级咨询员2级'
},
{
	id: '46',
	name: '审计员/咨询员3级'
},
{
	id: '49',
	name: '专员'
},
{
	id: '5',
	name: 'Administrative contractor'
},
{
	id: '51',
	name: '实习生'
},
{
	id: '52',
	name: '行政支持人员'
},
{
	id: '53',
	name: '实习生（CBS）'
},
{
	id: '55',
	name: '行政主管'
},
{
	id: '56',
	name: '行政专员'
},
{
	id: '57',
	name: '行政高级助理'
},
{
	id: '58',
	name: '行政助理'
},
{
	id: '61',
	name: '总监'
},
{
	id: '62',
	name: '高级经理'
},
{
	id: '63',
	name: '经理'
},
{
	id: '64',
	name: '主管专员'
},
{
	id: '65',
	name: '高级专员'
},
{
	id: '66',
	name: '专员'
},
{
	id: 'Not available',
	name: 'Not available'
},
{
	id: null,
	name: 'Allocation'
},
];

export const financialAnalysis = {
	noResultFound: '没找到所选选项的结果',
	allServiceLines: '所有业务线',
	allSubServiceLines: '所有子业务线',
	allMembers: '所有成员',
	allAvailable: '全部可用',
	allAdded: '已全部添加',
	selectAll: '选择全部',
	noResult: '未发现结果',
	noneSelected: '无选择',
	clearAllSeleted: '清空已选择#',
	showSelected: '显示已选择项目',
	allRanks: '所有职级'
};

export const independenceStatus = [{
	value: 1,
	label: 'Incomplete - Not invited'
},
{
	value: 2,
	label: 'Incomplete - In progress'
},
{
	value: 3,
	label: 'Completed - Other'
},
{
	value: 4,
	label: 'Completed - Validated In EY Canvas'
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: 'Incomplete'
},
{
	value: 2,
	label: 'No Matters Identified'
},
{
	value: 3,
	label: 'Matter Identified - Pending Action'
},
{
	value: 4,
	label: 'Matter Resolved - Denied Access'
},
{
	value: 5,
	label: 'Matter Resolved - Granted Access'
},
{
	value: 6,
	label: 'Not Applicable'
},
{
	value: 7,
	label: 'Restored'
},
{
	value: 8,
	label: 'Override'
},
{
	value: 9,
	label: 'Prior - No Matters Identified'
},
{
	value: 10,
	label: 'Prior - Matter Identified - Pending Action'
},
{
	value: 11,
	label: 'Prior - Matter Resolved - Granted Access'
},
{
	value: 12,
	label: 'Prior - Matter Resolved - Denied Access'
}
];

export const eycanvasIndependenceStatusAvailableOnUI = [{
	value: 1,
	label: 'Incomplete'
},
{
	value: 2,
	label: 'No Matters Identified'
},
{
	value: 3,
	label: 'Matter Identified - Pending Action'
},
{
	value: 4,
	label: 'Matter Resolved - Denied Access'
},
{
	value: 5,
	label: 'Matter Resolved - Granted Access'
},
{
	value: 6,
	label: 'Not Applicable'
},
{
	value: 7,
	label: 'Restored'
},
{
	value: 8,
	label: 'Override'
},
{
	value: 9,
	label: 'Prior - No Matters Identified'
},
{
	value: 11,
	label: 'Prior - Matter Resolved - Granted Access'
},
{
	value: 12,
	label: 'Prior - Matter Resolved - Denied Access'
},
{
	value: 13,
	label: 'Not Invited'
}
];

export const availableUserRoles = [{
	value: 1,
	label: 'Partner in Charge',
	displayOrder: 9
},
{
	value: 2,
	label: 'Engagement Partner',
	displayOrder: 8
},
{
	value: 3,
	label: 'Executive Director',
	displayOrder: 5
},
{
	value: 4,
	label: 'Principal',
	displayOrder: 6
},
{
	value: 5,
	label: 'Senior Manager',
	displayOrder: 4
},
{
	value: 6,
	label: 'Manager',
	displayOrder: 3
},
{
	value: 7,
	label: 'Senior',
	displayOrder: 2
},
{
	value: 8,
	label: 'Staff',
	displayOrder: 1
},
{
	value: 10,
	label: 'Engagement Quality Reviewer',
	displayOrder: 10
},
{
	value: 11,
	label: 'Other Partner',
	displayOrder: 7
},
{
	value: 12,
	label: 'GDS - Staff',
	displayOrder: 13
},
{
	value: 16,
	label: 'General Counsel',
	displayOrder: 12
},
{
	value: 17,
	label: 'Audit Quality Reviewer',
	displayOrder: 11
},
{
	value: 30,
	label: 'GDS - Senior',
	displayOrder: 14
},
{
	value: 31,
	label: 'GDS - Manager',
	displayOrder: 15
}
]

export const employmentStatusFilter = [{
	value: 'A',
	label: 'Active'
},
{
	value: 'L,P,U',
	label: 'Leave of absence'
},
{
	value: 'D,R,T',
	label: 'Terminated'
}
]

export const employmentStatus = [{
	value: 'A',
	label: 'Active'
},
{
	value: 'D',
	label: 'Terminated'
},
{
	value: 'L',
	label: 'Leave of absence'
},
{
	value: 'T',
	label: 'Terminated'
},
{
	value: 'P',
	label: 'Leave of absence'
},
{
	value: 'R',
	label: 'Terminated'
},
{
	value: 'U',
	label: 'Leave of absence'
},
]

export const independenceStatusDropdown = [{
	label: 'Incomplete',
	options: [{
		value: 1,
		label: 'Incomplete - Not invited'
	},
	{
		value: 2,
		label: 'Incomplete - In progress'
	}
	]
},
{
	label: 'Complete',
	options: [{
		value: 3,
		label: 'Completed - Other'
	}
	]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: 'EY Canvas independence status'
},
{
	id: 3,
	label: 'Member firm'
},
{
	id: 4,
	label: 'Country'
},
{
	id: 5,
	label: 'Hours charged'
},
{
	id: 6,
	label: 'Overall independence status'
},
{
	id: 7,
	label: 'Confirmation date'
},
{
	id: 8,
	label: 'Employment Status'
},
{
	id: 9,
	label: 'Updated by'
},
{
	id: 10,
	label: 'Updated date'
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: 'Completed outside of EY Canvas - No Matters Identified',
	isDisplayed: true
},
{
	value: 7,
	label: 'Completed outside of EY Canvas - Matters Identified',
	isDisplayed: true
},
{
	value: 8,
	label: 'Completed outside of EY Canvas - Matters Resolved',
	isDisplayed: true
},
{
	value: 2,
	label: 'Always a covered person',
	isDisplayed: true
},
{
	value: 3,
	label: 'No longer with the Firm',
	isDisplayed: true
},
{
	value: 4,
	label: 'Leave of absence',
	isDisplayed: true
},
{
	value: 5,
	label: 'Terminated',
	isDisplayed: false
},
{
	value: 6,
	label: '其他',
	isDisplayed: false
}
];

export const common = {
	selected: '已选定',
	cancel: '取消',
	checkbox: {
		selectAllOn: '选择全部',
		selectAllOff: '取消全部选择'
	},
	clear: '清空',
	close: '关闭',
	nav: {
		projectName: 'Project name'
	},
	pagination: {
		show: '显示',
		iconHover: {
			first: '第一页',
			previous: '上一页',
			next: '下一页',
			last: '最后页'
		}
	},
	search: {
		clear: '清空搜索',
		buttonTitle: '搜索',
		placeholder: '搜索',
		noResultsPlaceholder: '未发现结果'
	},
	table: {
		remove: '删除',
		noDataPlaceholder: '无可用数据',
		noResultsPlaceholder: '未发现结果'
	},
	toggleSwitch: {
		no: '否',
		yes: '是'
	},
	wizard: {
		next: '继续',
		back: '返回',
		finish: '完成'
	},
	unsavedChanges: 'Unsaved changes',
	unsavedChangesDescription: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to undo your changes?'
};

export const project = {
	myProjects: '我的项目',
	priorProjects: '前期项目',
	searchForBudgets: '搜索',
	emptyContainer: '您没有任何活跃预算。选择“创建预算”，然后开始。',
	noResultsFound: '未找到结果。',
	create: {
		title: '创建项目',
		clientCode: '客户编码',
		clientCodeInfo: '镜像编码无法被识别。使用发出编码的系统中的代码（即Mercury或GFIS）。',
		clientName: '客户名称',
		clientNamePlaceholder: '输入客户编码，搜索客户名称',
		name: '项目名称',
		rate: '默认每小时费率',
		rateInfo: '将使用默认的每小时费率计算预算的工时数。费率计算方法为开票服务费除以预计总工时。',
		percentage: '预计变现百分比',
		percentageInfo: '预期的变现百分比将用于计算Mercury或GFIS计费的小时数的时间价值。',
		relateEngagementsInstructionalText: '选择将用于此项目的一个或多个EY Canvas项目。这些项目的统计数据将和财务数据一同展示。只显示目前可以访问的项目。',
		selectClientAndWorkspaceInstructionalText: '选择客户和工作区，筛选出将与本项目关联的EY Canvas项目。',
		engagementPanelPlaceholder: '选择客户和工作区，显示建议的项目。',
		engagementPanelNoResultsFound: '未找到结果',
		emptyEngagements: '无可用的EY Canvas项目。在EY Canvas创建一个新项目，然后开始。',
		selectClient: '选择客户',
		selectWorkspace: '选择工作区',
		selectEngagements: '选择项目',
		selectedEngagements: '已添加项目',
		selectedEngagementError: '选择一个或多个项目然后继续',
		searchEngagements: '搜索项目',
		searchUsers: '搜索用户',
		engagementLabel: '{0} | ID: {1}',
		addBtn: '添加',
		removeBtn: '删除',
		clientLbl: '客户',
		engagementCodeLbl: '项目编码',
		engagementTypeCodeLbl: '项目类型',
		engagementNameLbl: '项目名称',
		engagementId: 'ID',
		addedByLbl: '添加人',
		engagementDescriptionLbl: '项目说明',
		systemLbl: '系统',
		noEngagementsLabel: '将项目编码关联至本项目。',
		step4InstTxt: '选择一个或多个项目编码与项目相关联。',
		relatedEngagementCodesSubtitle: '已关联项目编码',
		relatedEngagementCodeLink: '关联Mercury或GFIS的项目编码。镜像编码无法被识别。',
		unauthorizedModalHeader: '未授权用户',
		unauthorizedText: '您未被授权实施关联操作',
		allowedUsersText: '有权进行此操作的人员列表如下所示。',
		closeBtn: '关闭',
		validateBtn: '验证',
		relatedEngagementAddLabel: '关联Mercury或GFIS的项目编码。镜像编码无法被识别。',
		todayLbl: '今天',
		NoEmailMessage: '未提供邮箱',
		noEngagementsAdded: '未添加项目',
		selectToImport: '选择EY Canvas项目，将用户导入至此项目。',
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: '已添加成员',
		employeeName: '成员',
		role: '职能',
		manageTeamInstructionalText: '从关联的EY Canvas项目中选择活跃的项目组成员，按照以下说明添加未加入EY Canvas项目的其他项目组成员。',
		currentUser: '当前用户',
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [{
			stepName: '步骤1',
			stepDescription: '输入项目详细信息',
			active: true
		},
		{
			stepName: '步骤2',
			stepDescription: 'Select EY Canvas engagements'
		},
		{
			stepName: '步骤3',
			stepDescription: '管理访问权限',
			relatedEngagementCodesSubtitle: '已关联项目编码',
			relatedEngagementCodeLink: '关联Mercury或GFIS的项目编码。镜像编码无法被识别。',
			unauthorizedModalHeader: '未授权用户',
			unauthorizedText: '您未被授权实施关联操作',
			allowedUsersText: '以下为可执行此操作的人员列表。',
			close: '关闭'
		},
		{
			stepName: '步骤4',
			stepDescription: '连接至Mercury/GFIS'
		},
		{
			stepName: 'Step 5',
			stepDescription: 'Associate engagement codes to EY Canvas engagements',
			isExit: true
		}
		],
		ratePerHour: '每小时费率',
		realizationPercentage: '变现百分比'
	},
	stepOne: {
		enterProjectName: '输入项目名称然后继续'
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		clientName: '客户',
		workspace: 'Workspace',
		engagementCode: '项目代码',
		canvasEngagementName: 'EY Canvas Engagement',
		changes: '变动',
		tooltipMessages: {
			clientName: '客户名称',
			clientCode: '客户代码',
			engagementCode: '项目代码',
			engagementDescription: '项目名称',
			workspaceID: 'Workspace ID',
			workspaceDescription: 'Workspace名称'
		}
	},
	stepThree: {
		editTeamMembers: '编辑项目的项目组成员。',
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: '向项目添加项目组成员。',
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: '成员',
		projectAdministrator: '项目管理员',
		clickHere: '点击此处',
		nameOrEmail: '姓名或邮箱',
		addNewMember: '添加',
		firstName: '名字',
		lastName: '姓氏',
		inviteAndClose: '邀请并关闭',
		inviteAndAddAnother: '邀请并添加另一个',
		clear: '清空'
	},
	stepFour: {
		engagementCode: '项目代码',
		clientName: '客户',
		validation: '状态',
		independenceOnly: 'Independence only',
		noEngagementCodes: '没有为项目添加项目代码',
		addNewMember: '添加',
		addEngagementManually: '添加项目代码',
		addEngagementCodes: '添加项目代码',
		editEngagementCodes: '编辑项目代码',
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: '对于Mercury，在项目代码中添加项目类型前缀（如E-12345678）',
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: '输入项目代码',
		validate: '验证',
		engagementCodeRequired: '项目代码为必填项',
		searchNoResults: "未找到结果"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: '未发现结果'
		},
		canvasEngagements: {
			searchButtonTitle: 'Search',
			clearButtonTitle: 'Clear',
			noResults: '未发现结果',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
			displayUnassociatedEngagements: 'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: '删除项目',
	deleteDescription: '是否确定针对所有用户删除该项目？',
	deleteDescText: '此操作无法撤销。',
	delete: '删除',
	cancel: '取消',
	close: '关闭',
	confirm: '确定',
	leaveProject: '离开',
	leaveDescription: '是否确认离开该项目？你的项目组成员仍可继续访问该项目。',
	change: '变动',
	changes: '变动'
};

export const users = {
	settings: {
		title: '用户设置',
		firstName: '名字',
		lastName: '姓氏',
		displayLanguage: '显示语言',
		numberFormat: '数字格式',
		negativeNumberFormat: '负数格式',
		currencyFormat: '货币格式',
		dateFormat: '日期格式',
		roundingFormat: '取整格式',
		save: '保存',
		cancel: '取消',
		errorMessageSelect: '请选择一个值。',
		errorMessageInput: '请输入有效值。',
		isRequired: '必填。',
		preferences: '首选项',
		yourDelegates: '您的委托人',
		yourDelegatesDescription: '您授权可以在Mercury或GIFS中按照项目编码（您当前有访问权限）检索财务数据的用户',
		delegationsFromOthers: '其他成员委托',
		delegationsFromOthersDescription: '授权您可以在Mercury或GIFS中按照项目（用户当前有访问权限）检索财务数据的用户',
		noUsersIdentified: '未找到用户',
		addADelegate: '添加委托人',
		theme: '主题',
		preferredCurrency: '首选货币',
		status: '状态'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: '筛选客户',
		filter: '筛选',
		searchPlaceholder: '搜索',
		searchClearHoverText: '清空',
		searchHoverText: '搜索',
		unvalidated: '未验证',
		noData: 'No EY Canvas engagement associated',
		noResults: '未发现结果',
		noInformationAvailable: '所选选项没有可用信息。',
		independence: "独立性 ",
		noDataFound: 'No data found',
	},
	roundingType: '取整：',
	roundingFormats: {
		none: '无',
		thousands: '千',
		millions: '百万',
		lakhs: '十万',
		crores: '千万'
	},
	updatedDateType: {
		financialDateLabel: 'Financial data',
		updatedOn: 'updated on',
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: '项目总收入',
			actualTER: '实际项目总收入',
			billed: '已开账单',
			actualBilling: '实际账单金额',
			totalEngagementRevenue: '项目总收入（服务费+费用）',
			forecastedTER: '预测的项目总收入'
		},
		margin: {
			margin: '利润',
			target: '目标'
		},
		globalDeliveryService: {
			gds: 'GDS使用情况',
			globalDeliveryService: '全球交付中心'
		}
	},
	currency: '货币：',
	globalCurrency: '全球',
	localCurrency: '本地',
	noDataAvailable: '在选定筛选条件下无可用数据',
	actualHours: '实际时长',
	etc: 'ETC',
	ftaVariance: 'FTA差异',
	completedTasks: '已完成任务',
	closedAssignments: '已关闭工作分配',
	acceptedRequests: '已接受请求',
	gDSUsage: 'GDS使用情况',
	summaryHeaderPartner: '合伙人',
	summaryHeaderPpedd: 'PPEDD',
	summaryHeaderExecutive: '主管',
	financialProgressCard: {
		financialProgress: '财务进度',
		financialDetails: '财务细节',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: '成本',
		hours: '小时',
		expandDetails: '展开详细信息',
		expand: '展开',
		collapse: 'Collapse',
		collapseDetails: 'Collapse details',
		margin: '利润',
		marginPercentage: '利润',
		rphAcronym: 'RPH',
		cphAcronym: 'CPH',
		mphAcronym: 'MPH',
		eafAcronym: 'EAF',
		actual: '实际',
		budgeted: '预算',
		forecasted: '预测',
		ftaVariance: 'FTA差异',
		ftaVarianceTooltip: '预测值与实际值偏差',
		rph: '每小时费率',
		cph: '每小时成本',
		mph: '每小时利润',
		ansrCost: 'NSR / Cost',
		serviceLine: '业务线',
		subServiceLine: '子业务线',
		teamMember: '项目组成员',
		totalAnsr: 'Total NSR',
		totalCost: '总成本',
		totalHours: '总小时',
		ansrLabelText: 'Net standard revenue',
		rank: '职级',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: '显示',
		first: '第一个',
		last: '最后一个',
		previous: '上一步',
		next: '下一步'
	},
	financialFilters: {
		serviceLine: '业务线',
		subServiceLine: '子业务线',
		rank: '职级',
		teamMember: '项目组成员',
		showMore: '更多',
		clear: '清空',
		clearAll: '清除全部',
		search: '搜索',
		noResultsPlaceholder: '无结果',
		noFiltersAvailable: '无筛选',
		yes: '是',
		no: '否',
		tooltip: '筛选',
		expenseType: 'Expense type',
		allocation: 'Allocation'
	},
	billingAndExpenses: {
		title: 'Actual billings to date',
		forecastedTer: 'TER预测',
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: '预测账单',
		collected: '已收取',
		collectedTooltip: 'Collected / Billed',
		unCollected: 'Uncollected',
		unCollectedTooltip: 'Uncollected / Billed',
		billed: 'Billed (Outstanding)',
		billedTooltip: 'Billed / Forecasted TER',
		billedTotal: 'Billed',
		unbilled: '未开账单',
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: '项目代码',
		invoiceDate: 'Invoice date',
		currency: 'Currency',
		invoiceNumber: 'Invoice number',
		amount: 'Amount',
		noInformationPlaceholder: 'No information available for the selected options.',
		actualTer: 'Actual TER',
		actualTerTooltip: 'Actual total engagement revenue (fees + expenses)',
		actualExpenseToDate: 'Actual expenses to date',
		displayBy: '按xxx显示数据',
		expenseType: 'Expense type',
		teamMember: '项目组成员',
		totalExpenseToDate: 'Total expenses to date',
		expenseTypeColumn: 'Expense type',
		teamMemberColumn: 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: '业务线',
		serviceLineColumn: 'Service line',
		rank: '职级',
		rankColumn: 'Rank',
		allocation: 'Allocation',
		allocationsExpense: 'Allocated expenses present',
	},
	independence: {
		teamMember: '项目组成员',
		hoursCharged: 'Hours charged',
		independenceStatus: 'Overall independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status',
		employmentStatus: 'Employment status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
		confirmationDateBefore: 'Confirmation date before',
		confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		rank: '职级',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		reason: 'Reason',
		engagementRole: 'Engagement role',
		location: 'Location',
		employeeStatus: 'Employee status',
		noResultsPlaceholder: '未发现结果',
		filter: {
			unassociatedFinancialCodes: 'Unassociated financial codes',
			unassociatedLabel: 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header: {
		hours: '小时',
		actualHours: '实际',
		forecastedHours: '预测',
		variance: 'FTA variance',
		other: '其他',
		ppedd: 'PPEDD',
		mgrSrMgr: 'SrMgr/Mgr',
		partnerHours: '合伙人工时',
		executiveDirector: '执行总监',
		seniorManager: '高级经理',
		manager: '经理',
		senior: '高级审计员',
		staff: '审计员',
		intern: '实习生',
		billed: '已开账单：',
		ter: '项目总收入：',
		forecastedTER: '预测的项目总收入:',
		margin: '利润',
		ansr: 'ANSR',
		cost: '成本',
		terSection: '项目总收入',
		billedSection: '已开账单',
		forecastedTERSection: '预测',
		forecastedTERSectionForHeader: 'Forecasted TER',
		completedTasks: '已完成任务',
		completedAssignments: '已关闭工作分配',
		acceptedRequests: '已接受请求',
		gdsUsage: 'GDS使用情况',
		completedTasksTooltip: '已完成',
		totalTasksTooltip: '合计',
		completedAssignmentsTooltip: '已关闭',
		totalAssignmentsTooltip: '合计',
		acceptedRequestsTooltip: '已接受',
		sentRequestsTooltip: '已发送',
		gdsHoursTooltip: 'GDS',
		actualHoursTooltip: '实际工时',
		otherTooltip: 'Other',
		otherHeaderTooltip: 'Other',
		ppeddTooltip: 'PPEDD',
		mgrSrMgrTooltip: 'SrMgr/Mgr',
		partnerHoursTooltip: 'Partner/Principal',
		executiveDirectorTooltip: 'ED/D',
		seniorManagerTooltip: 'Sr. Manager',
		managerTooltip: 'Manager',
		seniorTooltip: 'Senior',
		staffTooltip: 'Staff',
		internTooltip: 'Intern',
		varianceTooltip: 'Forecast to actual variance',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		marginTooltip: 'Margin = (ANSR - Cost) / ANSR',
		terSectionHover: 'Actual total engagement revenue (fees + expenses)',
		forecastedTERSectionHover: 'Forecasted total engagement revenue (fees + expenses)',
		billedSectionHover: 'Actual net invoice amount',
		gdsUsageHover: 'Global Delivery Service usage'
	},
	allocationsFilters: [{
		value: 1,
		label: 'Yes'
	}
	]
};

export const exportOptions = {
	buttonText: '导出',
	downloadCSV: '下载CSV',
	downloadJPEG: '下载JPEG',
	downloadPDF: '下载PDF',
	downloadPNG: '下载PNG',
	downloadSVG: '下载SVG',
	downloadXLS: '下载XLS',
	exitFullscreen: '退出全屏',
	viewFullscreen: '查看全屏',
	printChart: '打印流程'
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Manage users',
	projectsTab: 'Manage projects',
	administrators: 'Manage administrators'
};

export const projectUserStatus = {
	active: 'Active',
	inactive: 'Inactive',
};

export const projectUserRoles = {
	defaultUser: 'Default user',
	projectAdministrator: '项目管理员'
};

export const projectStatus = {
	active: 'Active',
	deleted: 'Deleted'
};

export const administratorRoles = {
	none: '无',
	adminReader: 'Admin reader',
	adminWriter: 'Admin writer',
	superAdmin: 'Super admin'
}

export const addUser = {
	firstName: '名字',
	lastName: '姓氏',
	enterFirstNameText: 'Enter first name, last name or email address of user and press enter to search',
	selectRole: 'Role',
	userRole: 'User role',
	clear: '清空',
	email: 'Email',
	role: '职能',
	cancel: '取消',
	addUser: 'Add User',
	close: '关闭',
	add: 'Add',
	addAdministrator: 'Add administrator',
	error1: 'The selected user is already a part of the project. Please review.',
	error2: 'Admin can only be priviledged user account'
};

export const adminManageProjects = {
	manageProjects: 'Manage projects',
	description: 'Search for a project by entering the project ID',
	projectId: 'Project ID',
	search: '搜索',
	clearSearch: 'Clear',
	enterValidProject: 'Enter valid project ID',
	projectDetails: 'Project details',
	enterProjectName: 'Enter project name',
	projectName: 'Project name',
	projectStatus: 'Project status',
	financialCodes: 'Financial codes',
	noFinancialCodes: 'No financial engagement codes are mapped to this project',
	engagementCode: '项目代码',
	client: 'Client',
	status: '状态',
	validatedBy: 'Validated by',
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: 'Members',
	gui: 'GUI',
	firstName: '名字',
	lastName: '姓氏',
	emailAddress: 'Email address',
	userRole: 'User role',
	validated: 'Validated',
	unvalidated: '未验证',
	enterValidGui: 'Enter a valid GUI for project ID',
	requiredProjectName: 'Project name cannot be blank',
	successToastMessage: 'Changes saved successfully',
	resetToastMessage: 'Reset completed',
	errorToastMessage: 'At least one project member is required to be a Project administrator. Please review the changes.',
	independenceOnly: 'Independence only',
	yes: '是',
	no: '否'
};

export const manageAdministrators = {
	title: 'Manage administrators',
	firstName: '名字',
	lastName: '姓氏',
	email: 'Email',
	role: '职能',
	description: 'Add new administrators or manage existing administrators',
	noInformationPlaceholder: 'No information available for the selected options.',
	updateAdminErrorToast: 'Update was unsuccessful. Please review and try again later.',
	updateAdminSuccessToast: 'Changes saved successfully',
};

export const adminManageUsers = {
	title: 'Manage users',
	description: 'Search for a user by entering their user GUI',
	inputLabel: 'User GUI',
	searchButtonLabel: 'Search',
	cancelButtonLabel: 'Clear',
	errorMessage: 'Enter a valid user GUI',
	userDetails: 'User details',
	projects: 'Projects',
	delegates: 'Delegates',
	settings: 'Settings',
	noResultsPlaceholder: 'No records found',
	delegatedTo: 'Delegated to:',
	delegatedFrom: 'Delegated from:',
	gui: 'GUI',
	firstName: '名字',
	lastName: '姓氏',
	emailAddress: 'Email address',
	projectName: 'Project name',
	projectId: 'Project ID'
};

export const adminCommon = {
	save: '保存',
	reset: 'Reset'
}
